import React, { createContext, FC, ReactNode, useContext } from 'react';

import { DropdownItemProps } from './Dropdown.types';

type DropdownProviderProps = Pick<DropdownItemProps, 'active' | 'type' | 'onSelect'>;

const DropdownContext = createContext<DropdownProviderProps>({} as DropdownItemProps);

export const useDropdownProvider = (): DropdownProviderProps => useContext<DropdownProviderProps>(DropdownContext);

export const DropdownProvider: FC<DropdownProviderProps & { children: ReactNode }> = ({ children, ...props }) => {
  return <DropdownContext.Provider value={{ ...props }}>{children}</DropdownContext.Provider>;
};
